export const TriangleWarning = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.76 14.0665L11.4933 3.51984C11.18 2.9865 10.6267 2.6665 10 2.6665C9.37333 2.6665 8.82 2.9865 8.51333 3.51984L2.24 14.0665C1.92667 14.6132 1.92667 15.2598 2.24 15.7998C2.55333 16.3398 3.11333 16.6665 3.73333 16.6665H16.2733C16.9 16.6665 17.46 16.3398 17.7667 15.7998C18.0733 15.2598 18.0733 14.6132 17.76 14.0665ZM16.6133 15.1332C16.58 15.1932 16.48 15.3265 16.2733 15.3265H3.72667C3.52 15.3265 3.42 15.1865 3.38667 15.1332C3.35333 15.0798 3.28667 14.9198 3.38667 14.7398L9.66 4.19317C9.76 4.01984 9.93333 3.99984 10 3.99984C10.0667 3.99984 10.2333 4.01984 10.34 4.19984L16.6067 14.7465C16.7133 14.9198 16.64 15.0798 16.6067 15.1398L16.6133 15.1332ZM9.33333 7.33317H10.6667V11.3332H9.33333V7.33317ZM9.33333 12.6665H10.6667V13.9998H9.33333V12.6665Z"
        fill="currentColor"
      />
    </svg>
  );
};
